import { Admin } from "@/types";
import { formatDate, ResourceName } from "@/utils";
import { FC } from "react";
import {
  Datagrid,
  FunctionField,
  List,
  Pagination,
  TextField,
} from "react-admin";
import { ActionField } from "../action-field";
import { AdminCellName } from "../admin-name-cell";
import { TopToolbar } from "../top-toolbar";

const AdminUsersList: FC = () => {
  return (
    <List<Admin>
      perPage={30}
      actions={<TopToolbar />}
      pagination={<Pagination rowsPerPageOptions={[10, 15, 30, 50]} />}
      sort={{ field: "createdAt", order: "ASC" }}
      empty={<></>} // needn't empty list component
    >
      <Datagrid
        rowClick={"show"}
        bulkActionButtons={false}
        style={{ tableLayout: "fixed" }}
      >
        <AdminCellName
          label="Admin Name"
          source=""
          sortable={false}
          resourceName={ResourceName.ADMIN_USERS}
        />
        <TextField<Admin> label="Role" source="role" sortable={false} noWrap />
        <TextField<Admin>
          label="Email"
          source="email"
          sortable={false}
          noWrap
        />
        <FunctionField<Admin>
          label="Phone"
          sortable={false}
          render={({ phoneNumber }) => phoneNumber || "—"}
        />
        <FunctionField<Admin>
          label="Created"
          sortable={true}
          render={({ createdAt }) => formatDate(createdAt)}
        />
        <ActionField label="Action" />
      </Datagrid>
    </List>
  );
};

export { AdminUsersList };
